export function normalizeCoverImage(nextCoverImage) {
  if (nextCoverImage === null) {
    return null;
  }

  if (!nextCoverImage || typeof nextCoverImage !== 'object') {
    return undefined;
  }

  const imageId = nextCoverImage.image_id;
  if (!imageId || typeof imageId !== 'string') {
    return undefined;
  }

  return {
    image_id: imageId,
    image_original_data:
      nextCoverImage.image_original_data && typeof nextCoverImage.image_original_data === 'object'
        ? nextCoverImage.image_original_data
        : {}
  };
}
